import { Avatar, AvatarProps } from "@mui/material";
import { useSettings } from "@sinch/core/providers/AppSettings";
import type { User, File } from "@sinch/types/sinch.types";

import React, { FC } from "react";
import { useWorker } from "../Worker/hooks";

export interface UserAvatarProps extends AvatarProps {
  worker: Pick<User, "name" | "surname"> & {
    avatar?: Pick<File, "url"> | null;
  };
}

/**
 * Avatar for user
 */
export const UserAvatar: FC<UserAvatarProps> = ({ worker, ...props }) => {
  const { getWorkerName } = useWorker();
  const { avatarDummy } = useSettings();
  return (
    <Avatar alt={getWorkerName(worker)} src={worker.avatar?.url ?? avatarDummy} {...props}>
      {worker.name?.[0]}
      {worker.surname?.[0]}
    </Avatar>
  );
};
